import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";

const LandUseMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const landUse = getMetricGroupOrderIds(tab);

    const sortedLandUseMetrics = landUse.map((order: number[]) => 
        categorizedData["Land use"]
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('sortedLandUseMetrics:', sortedLandUseMetrics);

    const lMetrics: DisaggregatedMetric[] = sortedLandUseMetrics[0];

    let metricsForTab = indicators; // Get metrics for the current tab

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    return (
        <>
            <div className="grid grid-cols-2 gap-4 place-items-start ml-4">
                {lMetrics?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
            </div>
        </>
    );
}

export default LandUseMetrics;